import {
    Component,
    EventEmitter,
    Input,
    InputSignal,
    OnInit,
    Output,
    Signal,
    WritableSignal,
    computed,
    effect,
    inject,
    input,
    output,
    signal,
    untracked,
} from '@angular/core';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { CommonModule } from '@angular/common';
import { IIqSocialLinks } from '../models';

@Component({
    selector: 'iq-social-links-podcast',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-social-links-podcast.component.html',
    styleUrl: './iq-social-links-podcast.component.scss',
})
export class IqSocialLinksPodcastComponent {
    @Input()
    id: string;

    private _eventBus: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );

    podcasts: IIqSocialLinks[] = [
        {
            label: 'Proof of Delivery',
            url: 'https://www.youtube.com/playlist?list=PLTpmz3tZwPhCcuXxDl5JixyJO_SwtrNv6',
        },
        {
            label: 'Freightvine',
            url: 'https://www.dat.com/resources/freightvine',
        },
        {
            label: 'Freight Focus',
            url: 'https://www.dat.com/resources/freightfocus',
        },
    ];

    onClick(url: string) {
        /**
         * This dispatches an event when the component clicks on a podcast link
         *
         *
         * To listen to these events, you can use the following format in your Dashboard, Section, or Component:
         *
         * ```json
         * {
         *  "onClick": [
         *    {
         *      "name": "EVENT_NAME",
         *      "payload": {},
         *      "sourceEventRule": {
         *          "payload": [
         *            {
         *                "path": "id",
         *                "operator": "eq",
         *                "value": "COMPONENT_ID"
         *            },
         *            {
         *                "path": "componentName",
         *                "operator": "eq",
         *                "value": "IqTableRateRecentSearch"
         *            },
         *          ]
         *      },
         *      "rules": []
         *    },
         *   ],
         * }
         * ```
         */
        const dispatch = () =>
            this._eventBus.dispatch({
                name: 'type:click',
                payload: {
                    id: this.id,
                    componentName: 'IqSocialLinksPodcast',
                    url,
                },
            });

        dispatch();
    }
}
